var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from "vue-property-decorator";
import LeaveCaseApply from "~/components/apply-component/leave-case-apply.vue";
import { namespace } from "vuex-class";
import { ApplyType } from "~/config/enum.config";
var CollectionExecutionModule = namespace("collection-execution");
var LeaveCaseButton = /** @class */ (function (_super) {
    __extends(LeaveCaseButton, _super);
    function LeaveCaseButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = false;
        _this.applyType = {};
        return _this;
    }
    LeaveCaseButton.prototype.onClickButton = function () {
        this.applyType = ApplyType.leave;
        this.dialog = true;
    };
    __decorate([
        CollectionExecutionModule.State
    ], LeaveCaseButton.prototype, "caseId", void 0);
    LeaveCaseButton = __decorate([
        Component({
            components: {
                LeaveCaseApply: LeaveCaseApply
            }
        })
    ], LeaveCaseButton);
    return LeaveCaseButton;
}(Vue));
export default LeaveCaseButton;
